import React from 'react';
import RelatedObject from '../RelatedObject/RelatedObject';
import styles from './Body.module.scss';

const Body = ({ relatedObjects }) => {
  return (
    <div clnassName={styles.root}>
      <div className={styles.body}>
        {relatedObjects?.map((item) => (
          <RelatedObject
            key={item.id}
            item={item}
          />
        ))}
      </div>
    </div>
  );
};

export default Body;
